// react + redux
import React from "react"
import { connect } from "react-redux"
import { mapDispatchProps, mapStateToProps } from "../../store/store"
// modules
import { Modal } from "antd"
// components
import { useLanguage } from "@languages/index"

// Props Interface
interface Props {
  isVisible: boolean
  onClose?: () => void
  onOk?: () => void
  zIndex?: number

  name: string
  avatarSrc: string
}

const ModalContactManager = (props: Props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.invite }

  return (
    <Modal
      className="squared-antd-modal"
      style={{ padding: "40px 20px 40px 20px" }}
      width={400}
      zIndex={props.zIndex ?? 1010}
      centered={true}
      closable={false}
      footer={null}
      open={props.isVisible}
      onCancel={props.onClose}
    >
      <div className="flex flex-col gap-[30px] py-[50px]">
        <div className="flex flex-col justify-center mx-auto items-center gap-[10px]">
          <img src={`${props.avatarSrc}`}></img>
          <div className="text-black text-[17px] font-bold">{languageTexts.intro_text_25}</div>
          {/* <img className="max-w-[58px]" src={`/assets/logo/logo-black-sm.svg`}></img> */}
        </div>
        <div className="text-center text-black text-[17px] font-normal py-[15px]">
          {languageTexts._intro_text_26(props.name)}
        </div>
      </div>

      <div className="w-full flex flex-col pb-[50px]">
        <div
          className="flex justify-center items-center w-[140px] h-12 bg-orange-500 rounded-[41px] mx-auto cursor-pointer"
          onClick={props.onOk ? props.onOk : null}
        >
          <div className="text-center text-white text-[17px] font-bold">{languageTexts.confirm}</div>
        </div>
      </div>
    </Modal>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(ModalContactManager)
